import React, { useImperativeHandle, useRef, useState, useEffect } from "react";
import { Autocomplete, TextField, Typography, Box } from "@mui/material";
import "../../../common/commonStyles.css";

const ProductSearch = React.forwardRef(({ 
  selectedProduct, 
  onProductChange, 
  searchInput, 
  onSearchInputChange, 
  options, 
  isLoading,
  selectedCustomer,
  debouncedSearch
}, ref) => {
  const autocompleteRef = useRef(null);
  const [shouldOpenOnFocus, setShouldOpenOnFocus] = useState(true);
  const focusTimeoutRef = useRef(null);

  useImperativeHandle(ref, () => ({
    focusInput: () => {
      if (autocompleteRef.current) {
        setShouldOpenOnFocus(false);
        const inputElement = autocompleteRef.current.querySelector('input');
        if (inputElement) {
          inputElement.focus();
        }
        if (focusTimeoutRef.current) {
          clearTimeout(focusTimeoutRef.current);
        }
        focusTimeoutRef.current = setTimeout(() => {
          setShouldOpenOnFocus(true);
        }, 300);
      }
    },
    autocompleteRef: autocompleteRef
  }));

  useEffect(() => {
    return () => {
      if (focusTimeoutRef.current) {
        clearTimeout(focusTimeoutRef.current);
      }
    };
  }, []);

  return (
    <Autocomplete
      ref={autocompleteRef}

      fullWidth
      openOnFocus={shouldOpenOnFocus}
      value={selectedProduct}
      onChange={(event, newValue) => onProductChange(newValue)}
      inputValue={searchInput}
      onInputChange={(event, newInputValue) => onSearchInputChange(newInputValue)}
      options={options}
      getOptionLabel={(option) => option.product_name || ""}
      filterOptions={(x) => x}
      loading={isLoading}
      disabled={!selectedCustomer}
      noOptionsText={
        !selectedCustomer 
          ? "Please select a customer first" 
          : debouncedSearch.length < 2 
          ? "Type at least 2 characters" 
          : "No products found"
      }
      renderInput={(params) => (
        <TextField
          className="input-border"
          {...params}
          label="Product"
          placeholder={!selectedCustomer ? "Select customer first" : "Enter Product Name"}
          margin="none"
          sx={{ 
            '& .MuiInputBase-root': { height: '35px' },
            '& .MuiFormLabel-root': { top: '-10px', color: '#000' },
            '& .MuiInputLabel-shrink': { top: '0 !important' },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#000",
            },
          }}
        />
      )}
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="body2" fontWeight={500}>{option.product_name}</Typography>
            </Box>
            <Typography variant="caption" color="text.secondary">
              Code: {option.product_code} | Size: {option.size} | {option.categorie_name}
            </Typography>
          </Box>
        </li>
      )}
    />
  );
});

ProductSearch.displayName = 'ProductSearch';

export default ProductSearch;

